import { avatarProfile } from "~/assets/svg";
import { DetailProfileData } from "../../components/detail-profile-data";
import { usePopupDetailProfile } from "../../popup-detail-profile.hooks";
import { PopupDetailProfileProps } from "../../popup-detail-profile.types";
import styles from "./popup-detail-profile-skin-1.module.css";
import { LazyVideo } from "@components-monorepo/components/Video/lazy-video";
import { ModalType, UiModal, UiButton } from "@ui-monorepo/index";

export const PopupDetailProfileSkin1 = ({
  showSocialButtons,
  showVideo,
  partner
}: PopupDetailProfileProps) => {
  const {
    t,
    theme,
    storeMetadata,
    partnerNetwork,
    storeIsPrime,
    showModalVideo,
    videoUrl,
    phone,
    partnerProfilePicture,
    handleClosePopupDetail,
    handleShare,
    triggerEvent,
    handleShowVideo,
    catalogueHomeUrl
  } = usePopupDetailProfile();

  const activeAddresses = partner?.userAddresses?.find(
    (address: any) => address?.active
  );
  const whatsAppText = t("common.message", {
    link: encodeURIComponent(catalogueHomeUrl)
  });

  return (
    <div aria-label='popup-detail-profile'>
      <UiModal
        title={t("detailProfile.title")}
        onClose={handleClosePopupDetail}
        type={ModalType.LEFT}
        content={{
          styles: {
            width: `375px`,
            padding: "0"
          }
        }}
        show={true}>

        <section className={`${styles.popupDetailProfileStyled}`}>
          <div className={`${styles.popupDetailProfileContent}`}>
            <header
              className={`${styles.popupDetailProfileHeader}`}
              style={{ backgroundImage: `url(${theme.cover?.webCover})` }}>

              <div className={`${styles.profileStoreAvatar}`}>
                <figure className={styles.storeLogo}>
                  <div
                    className={`${styles.link} ${
                    storeMetadata?.profilePicConfiguration?.enableRectangle && styles.rectangle
                    }`}>

                    <img
                      src={partnerProfilePicture}
                      alt={t("detailProfile.image_alt")}
                      className={styles.logo}
                      loading='lazy' />

                  </div>
                </figure>
                {storeIsPrime && <span className={`${styles.storePrime} icon-crown`} />}
              </div>

              <div className={`${styles.profileStoreName}`}>
                <h3 className={`${styles.storeName}`}>{storeMetadata?.enterpriseName}</h3>
                <p className={`${styles.storeCategory}`}>{storeMetadata?.enterpriseSector}</p>
              </div>
            </header>
            {showSocialButtons && partnerNetwork &&
            <div className={`${styles.popupDetailProfileSocial}`}>
                {partnerNetwork?.facebook &&
              <a href={`https://www.facebook.com/${partnerNetwork?.facebook}`} target='_blank' rel='noreferrer'>
                    <span className={`${styles.profileSocialIcon} icon-facebook-outline`}></span>
                  </a>}

                {partnerNetwork?.instagram &&
              <a href={`https://www.instagram.com/${partnerNetwork?.instagram}`} target='_blank' rel='noreferrer'>
                    <span className={`${styles.profileSocialIcon} icon-instagram-outline`}></span>
                  </a>}

                {partnerNetwork?.twitter &&
              <a href={`https://twitter.com/${partnerNetwork?.twitter}`} target='_blank' rel='noreferrer'>
                    <span className={`${styles.profileSocialIcon} icon-twitter-online`}></span>
                  </a>}

              </div>}

            <hr className={`${styles.popupDetailDivisor}`}></hr>
            <div className={`${styles.popupDetailProfileShare}`}>
              <UiButton link onClick={handleShare}>
                {t("share.share_it")}
                <span className='icon-share-outline'></span>
              </UiButton>
              {showVideo && videoUrl &&
              <>
                  <UiButton theme={theme} hasPersonalization isFilled onClick={handleShowVideo}>
                    {t("button.see_video")}
                    <span className='icon-play'></span>
                  </UiButton>
                  {showModalVideo &&
                <div className={`${styles.detailStoreVideo}`}>
                      <div className={`${styles.detailStoreVideoOverlayer}`} onClick={handleShowVideo}></div>
                      <LazyVideo
                    videoUrl={videoUrl}
                    styles={{
                      width: "70vw",
                      height: "40vw"
                    }}
                    theme={theme}
                    fullScreenControl={false}
                    storeMetadata={storeMetadata} />

                    </div>}

                </>}

            </div>
            {partner &&
            <DetailProfileData
              partner={partner.userDetail}
              activeAddresses={activeAddresses || undefined}
              className='popup-detail-profile-data' />}


          </div>
          <footer className={`${styles.popupDetailProfileFooter}`}>
            <a
              id='wp'
              className={`${styles.detailProfileFooterHelp}`}
              href={`https://api.whatsapp.com/send?text=${whatsAppText}&phone=${phone}`}
              target='_blank'
              rel='noreferrer'>

              <UiButton link onClick={triggerEvent}>
                {t("detailProfile.help")}
                <span className='icon-head-phones'></span>
              </UiButton>
            </a>
          </footer>
        </section>
      </UiModal>
    </div>);

};